module.exports = __webpack_public_path__ + "static/condo-2-236b20b1d5a434aae9a66ee366c48bcb.jpg";